import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const NoPaddingButtonMedium = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"noPadding Medium secondary button"}
        value={
          "<Button variant={'noPadding'} color={\"secondary\"}>Medium</Button>"
        }
      >
        <Button variant={"noPadding"} color={"secondary"}>
          Medium
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default NoPaddingButtonMedium;
